// extracted by mini-css-extract-plugin
export default {"emptyState":"emptyTblContainer_emptyState__BRoyz"};